import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Modal,
  Input,
  Select,
  DatePicker,
  Typography,
  Row,
  Col,
  Divider,
  Space,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import config from "../../config/form.json";
import { useRecoilValue, useSetRecoilState, useRecoilState } from "recoil";
import useNotify from "../../utils/useNotify";
import {
  inwardPartner,
  orgmode,
  productSelection,
  showloader,
  uboFlag,
  hasInwardBank,
  newPartnerList,
} from "../../store/gloabalState";
import SectionHeading from "./section-headings";
import DocsUpload from "../onboarding/authFileComponent";
import dayjs from "dayjs";
import {
  CountryCode,
  emailRegex,
  onlyNumericDigitsRegex,
  phoneRegex,
} from "../../config/globalVar";
import { handleSubmit } from "../../utils/onboarding/ubo/handle-submit";
import { getDirectors } from "../../services/httpCalls";
import {
  getProductionSelectionType,
  showField,
  NEW_REFACTOR,
} from "../../utils/onboarding/onboardingUtils";

const UboForm = ({
  open,
  setOpen,
  setRefresh,
  editFlag,
  editData,
  setEditFlag,
}) => {
  // initializing form
  const [form] = Form.useForm();

  // getting ubo config data
  const configData = config.ubo[0].uboFrom[0];

  // local states
  const [filesAdded, setFilesAdded] = useState();
  const [panDoc, setPanDoc] = useState();
  const [aadDoc, setAadDoc] = useState();
  const [newName, setNewName] = useState();
  const [passDoc, setPassDoc] = useState();
  const [directors, setDirectors] = useState();
  const [changeDoc, setChangeDoc] = useState("");
  const [namesList, setNamesList] = useState([]);
  const [uboFiles, setUboFiles] = useState();
  const [currentUbo, setCurrentUbo] = useState();

  // global states
  const partnerState = useRecoilValue(inwardPartner);
  const partnerListState = useRecoilValue(newPartnerList);

  // values
  const mode = useRecoilValue(orgmode);
  const selectionValue = useRecoilValue(productSelection);
  const hasInwardBankValue = useRecoilValue(hasInwardBank);

  // setter/updater
  const setShowLoader = useSetRecoilState(showloader);
  const setUboValidated = useSetRecoilState(uboFlag);

  // constants/binders
  const { hasOnlyPartners } = getProductionSelectionType(
    selectionValue,
    partnerState,
    hasInwardBankValue
  );
  const notify = useNotify();
  const dayjsInstance = dayjs;
  const CountryCodeInstance = CountryCode;
  const emailRegexRef = emailRegex;
  const phoneRegexRef = phoneRegex;
  const onlyNumericDigitsRegexRef = onlyNumericDigitsRegex;

  const dateFormat = "DD/MM/YYYY";

  const onFinish = async (values) => {
    handleSubmit({
      values,
      setShowLoader,
      filesAdded,
      editFlag,
      editData,
      notify,
      form,
      handleClose,
      setRefresh,
      setFilesAdded,
      setUboValidated,
      partnerState,
    });
  };

  const handleOpen = () => {
    setEditFlag(false);
    setOpen(!open);
    setChangeDoc("");
    setFilesAdded([]);
    setPanDoc(null);
    setPassDoc(null);
    form.resetFields();
  };

  const handleClose = () => {
    setOpen(!open);
    form.resetFields();
    setFilesAdded([]);
    setPanDoc(null);
    setPassDoc(null);
  };

  const addNewItem = () => {
    if (newName) {
      let names_ = namesList;
      if (!names_.includes(newName)) {
        names_.push(newName);
        setNamesList(names_);
        setNewName("");
      } else {
        notify.error("Name already exist!");
      }
    }
  };

  const handleDropdownRender = (menu) => {
    return (
      <>
        {menu}
        <Divider style={{ margin: "8px 0" }} />
        <Typography style={{ fontWeight: "bold", margin: "0.5rem" }}>
          Add new Name
        </Typography>
        <Space style={{ padding: "0 8px 4px" }}>
          <Input
            onChange={(e) => setNewName(e.target.value)}
            value={newName}
            placeholder="Enter Here"
          />
          <Button
            className="add-button"
            type="primary"
            icon={<PlusOutlined />}
            onClick={addNewItem}
          >
            Add
          </Button>
        </Space>
      </>
    );
  };

  const detailsFill = () => {
    let name = form.getFieldValue("name");
    if (name) {
      directors?.forEach((item) => {
        if (name === item.name) {
          setCurrentUbo(item);
          form.setFieldsValue({
            ["pan"]: item?.panNumber,
            ["firstName"]: item?.firstName ? item?.firstName : item?.name,
            ["lastName"]: item?.lastName,
            ["MotherName"]: item?.motherName,
            ["Fathername"]: item?.fatherName,
            ["email"]: item?.email,
            ["phoneNumber"]: item?.phoneNumber,
            ["gender"]: item?.gender,
            ["dob"]: item?.dob ? dayjs(item?.dob, dateFormat) : "",
            ["nationality"]: item?.nationality,
            ["addressLineOne"]: item?.address?.addressLineOne,
            ["addressLineTwo"]: item?.address?.addressLineTwo,
            ["city"]: item?.address?.city,
            ["country"]: item?.address?.country,
            ["state"]: item?.address?.state,
            ["pincode"]: item?.address?.pinCode,
            ["idNumber"]: item?.idNumber,
            ["designation"]: item?.designation,
            ["emailId"]: item?.emailId,
          });
          setChangeDoc(item?.nationality);
          let files_ = [];
          if (item?.docs?.length) {
            item?.docs?.forEach((elem) => {
              if (elem.type === "DIRECTOR_PAN") {
                let fileName = elem?.s3Url.split("/");
                fileName = fileName[fileName.length - 1];
                let doc_ = {
                  type: "UBO_PAN",
                  documentType: "UBO_PAN",
                  name: fileName,
                  copyOfOldDoc: true,
                  url: elem?.s3Url,
                };
                setPanDoc(doc_);
                files_.push(doc_);
              } else if (elem.type === "DIRECTOR_PASSPORT") {
                let fileName = elem?.s3Url.split("/");
                fileName = fileName[fileName.length - 1];
                let doc_ = {
                  type: "UBO_PASSPORT",
                  documentType: "UBO_PASSPORT",
                  name: fileName,
                  copyOfOldDoc: true,
                  url: elem?.s3Url,
                };
                setPassDoc(doc_);
                files_.push(doc_);
              } else if (elem.type === "DIRECTOR_ADHAAR") {
                let fileName = elem?.s3Url.split("/");
                fileName = fileName[fileName.length - 1];
                let doc_ = {
                  type: "DIRECTOR_ADHAAR",
                  documentType: "DIRECTOR_ADHAAR",
                  name: fileName,
                  copyOfOldDoc: true,
                  url: elem?.s3Url,
                };
                setAadDoc(doc_);
                files_.push(doc_);
              }
            });
          }
          if (files_.length) {
            setFilesAdded(files_);
          }
          setUboFiles(item?.docs);
        }
      });
    }
    if (
      name &&
      (!directors.length || directors.some((ele) => ele.name !== name))
    ) {
      let firstName = name?.split(" ")[0];
      let lastName = name?.slice(firstName.length).trim();

      form.setFieldsValue({
        ["firstName"]: firstName,
        ["lastName"]: lastName ? lastName : "",
      });
    }
  };

  const renderField = (field, index) => {
    const { type, label, name, props, style, tooltip } = field;

    // * formatting rules
    field?.rules?.forEach((item) => {
      if (item?.pattern) {
        item.pattern = eval(item?.pattern);
      }
      if (item?.required) {
        item.required = eval(item?.required);
      }
      if (item?.validator) {
        item.validator = eval(item?.validator);
      }
    });

    switch (type) {
      case "Form.Item":
        return (
          <React.Fragment>
            <Form.Item
              label={label}
              name={name}
              rules={field?.rules}
              tooltip={tooltip}
              labelCol={field?.labelCol}
              required={eval(field?.required)}
            >
              {field?.children ? renderField(field?.children, 0) : null}
            </Form.Item>
            {field?.subFields
              ? field?.subFields.map((child, childIndex) =>
                  renderField(child, childIndex)
                )
              : null}
          </React.Fragment>
        );
      case "Input":
        return (
          <Input
            disabled={eval(props?.disabled)}
            readOnly={eval(props?.readOnly)}
            name={field?.name}
            onKeyUp={eval(props?.onKeyUp)}
            maxLength={field?.maxLength}
          />
        );
      case "Button":
        return (
          <Button
            type={type}
            style={style}
            onClick={eval(props.onClick)}
            disabled={eval(props.disabled)}
          >
            {eval(label)}
          </Button>
        );
      case "Select":
        return (
          <Select
            options={eval(field?.options)}
            readOnly={eval(props?.readOnly)}
            disabled={eval(props?.disabled)}
            showSearch={props?.showSearch}
            allowClear={props?.allowClear}
            default={field?.default}
            filterOption={eval(props?.filterOption)}
            onKeyUp={eval(props?.onKeyUp)}
            optionFilterProp={props?.optionFilterProp}
            placeholder={field?.placeholder}
            dropdownRender={eval(props?.dropdownRender)}
            onChange={eval(props?.onChange)}
          />
        );
      case "DatePicker":
        return (
          <DatePicker
            format={eval(props?.dateFormat)}
            disabledDate={eval(props?.disabledDate)}
            style={field?.style}
          />
        );
      case "SectionHeading":
        return (
          <SectionHeading
            style={field?.style}
            level={field?.level}
            heading={field?.heading}
            Col={field?.Col}
          />
        );
      case "DocsUpload":
        return (
          <DocsUpload
            name={field?.name}
            type={field?.subType}
            doc={eval(props?.doc)}
            files={eval(props?.files)}
            filesAdded={eval(props?.filesAdded)}
            setFilesAdded={eval(props?.setFilesAdded)}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (editFlag) {
      form.setFieldsValue({
        ["name"]: editData?.name,
        ["firstName"]: editData?.firstName,
        ["lastName"]: editData?.lastName,
        ["percentage"]: editData?.shareholdingPercentage,
        ["phoneNumber"]: editData?.phoneNumber,
        ["gender"]: editData?.gender,
        ["dob"]: editData?.dob ? dayjs(editData?.dob, dateFormat) : "",
        ["nationality"]: editData?.nationality,
        ["designation"]: editData?.designation,
        ["addressLineOne"]: editData?.address?.addressLineOne,
        ["addressLineTwo"]: editData?.address?.addressLineTwo,
        ["city"]: editData?.address?.city,
        ["country"]: editData?.address?.country,
        ["state"]: editData?.address?.state,
        ["pincode"]: editData?.address?.pinCode,
        ["idNumber"]: editData?.idNumber,
        ["pan"]: editData?.idNumber,
        ["designation"]: editData?.designation,
        ["emailId"]: editData?.emailId,
      });
      setChangeDoc(editData?.nationality);
      editData?.docs?.forEach((elem) => {
        if (elem.type === "UBO_PAN") {
          setPanDoc(elem);
        } else if (elem.type === "UBO_PASSPORT") {
          setPassDoc(elem);
        } else if (elem.type === "DIRECTOR_ADHAAR") {
          setAadDoc(elem);
        }
      });
      // setDoc(editData?.docs[0])
    }
  }, [editFlag, open]);

  useEffect(() => {
    setShowLoader(true);
    let orgId = localStorage.getItem("orgId");
    getDirectors(orgId)
      .then((res) => {
        if (res !== "") {
          setDirectors(res);
          // let directors :any = []
          // res.forEach((item:any) => {
          //   if(item.designation?.toLowerCase() === "director"){
          //     directors.push(item)
          //   }
          // })
          res = res.filter((elem) => {
            if (elem.status === "ACTIVE") return elem;
          });
          if (res) {
            let names_ = [];
            res.forEach((elem) => {
              names_.push(elem.name);
            });
            setNamesList(names_);
          }
          let directors_ = JSON.parse(localStorage.getItem("directors_"));
          directors_?.forEach((elem) => {
            res.forEach((item, i) => {
              if (elem.name === item.name) {
                res[i] = elem;
                elem.docs.forEach((doc, d) => {
                  if (doc.type === "AUTHORIZED_SIGNATORY_ADHAAR") {
                    elem.docs[d].type = "DIRECTOR_ADHAAR";
                  } else if (doc.type === "AUTHORIZED_SIGNATORY_PAN") {
                    elem.docs[d].type = "DIRECTOR_PAN";
                  }
                });
              }
            });
          });
          setShowLoader(false);
        }
      })
      .catch(() => {
        notify.error("Not able to get data!");
      })
      .finally(() => {
        setShowLoader(false);
        setRefresh(false);
      });
  }, []);

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          handleOpen();
          setEditFlag(false);
          form.resetFields();
        }}
        block
        icon={<PlusOutlined />}
        disabled={mode === "view" ? true : false}
        style={{
          color: "#fff",
          width: "auto",
          margin: "1rem .5rem",
        }}
        className="add-button"
      >
        Add Beneficiary Owner Details
      </Button>
      <Modal
        open={open}
        onCancel={handleClose}
        width={800}
        style={{ top: 20 }}
        footer={null}
      >
        <Typography.Title level={4}>
          {editFlag
            ? "Edit Beneficiary Owner details"
            : "Add Beneficiary Owner Details"}
        </Typography.Title>
        <Form
          {...configData.formConfig}
          form={form}
          onFinish={onFinish}
          initialValues={{
            name: "",
          }}
        >
          <Row gutter={[16, 16]}>
            {configData.fields.map((field, index) => {
              const checkNaitonalityBoolean =
                hasOnlyPartners && partnerState.includes("payglocal")
                  ? true
                  : field?.checkNationality
                  ? changeDoc === field?.checkNationality
                  : true;

              const isVisible =
                showField(field.productList, partnerListState) &&
                checkNaitonalityBoolean;

              const isRefactoredRender = isVisible;

              return (
                isRefactoredRender && (
                  <Col key={index} span={field?.Col ? field.Col : 12}>
                    {renderField(field, index)}
                  </Col>
                )
              );
            })}
          </Row>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <div className="cancel">
              <Button
                onClick={() => {
                  setOpen(!open);
                }}
                style={{ marginRight: "16px" }}
              >
                Cancel
              </Button>
            </div>
            <div className="submit">
              <Button htmlType="submit" type="primary">
                Submit
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default UboForm;
